// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment';
import { EXPIRED_MEMBER_INVITED_DAYS } from '../constants/parties';
import {
  fakeBachelorActivities,
  fakeBacheloretteActivities,
} from '../constants/events';

export function sortByName(a, b) {
  const nameA = a.memberName.toLowerCase();
  const nameB = b.memberName.toLowerCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
}

export function getCodeStatus(member, partyTz) {
  const { inviteCode, status, invitedAt } = member;
  if (!inviteCode) return '';
  if (status === 'pending') {
    if (!invitedAt) return '';
    const now = moment.tz(partyTz);
    const diffDays = moment.duration(now.diff(invitedAt)).asDays();
    return diffDays > EXPIRED_MEMBER_INVITED_DAYS ? 'Expired' : '';
  }
  return 'Used';
}

export function getInviteType(member) {
  const { inviteCode, memberPhone, memberEmail } = member;
  if (!inviteCode) return '';
  if (memberPhone) return 'SMS';
  if (memberEmail) return 'Email';
  return '';
}

export function getPartyMembersWithoutDuplicates(members) {
  return members.filter(member => member.status !== 'joined');
}

export function getAcceptedPartyMembers(members) {
  return members.filter(member => !member.status);
}

export function mapFromPartyToPartyCSV(party) {
  const { partyLocation, startDate, endDate, createdAt } = party;
  return {
    ...party,
    startDate: startDate ? moment(startDate).format('MM-DD-YYYY') : '',
    endDate: endDate ? moment(endDate).format('MM-DD-YYYY') : '',
    createdAt: createdAt ? moment(createdAt).format('MM-DD-YYYY') : '',
    partyLocation: partyLocation ? partyLocation.address : '',
  };
}

export function getIdeasList(party) {
  if (party.gender === 'bride') {
    return fakeBacheloretteActivities;
  }
  if (party.gender === 'groom') {
    return fakeBachelorActivities;
  }
  return [...fakeBacheloretteActivities, ...fakeBachelorActivities];
}
